import { SwiperOptions } from 'swiper';

export const HIGHLIGHTED_SWIPER_CONFIG: SwiperOptions = {
	slidesPerView: 1.2,
	spaceBetween: 25,
	lazy: true,
	breakpoints: {
		'640': {
			slidesPerView: 1,
			spaceBetween: 5,
		},
		'1024': {
			slidesPerView: 3,
			spaceBetween: 10,
		},
		'1440': {
			slidesPerView: 3,
			direction: 'horizontal',
			grid: { rows: 2, fill: 'row' },
		},
	},
};

export const HORIZONTAL_SWIPER_CONFIG: SwiperOptions = {
	slidesPerView: 2.2,
	spaceBetween: 10,
	lazy: true,
	breakpoints: {
		'640': {
			slidesPerView: 2,
			spaceBetween: 5,
		},
		'1024': {
			slidesPerView: 3,
			spaceBetween: 10,
		},
		'1440': {
			slidesPerView: 4,
			spaceBetween: 10,
		},
	},
};

export const STANDARD_SWIPER_CONFIG: SwiperOptions = {
	slidesPerView: 1,
	spaceBetween: 10,
	lazy: true,
	pagination: {
		clickable: true,
		renderBullet: () => {
			return '<span class="swiper-pagination-bullet custom !bg-mainColor"></span>';
		},
	},
	breakpoints: {
		'640': {
			slidesPerView: 2,
			spaceBetween: 5,
		},
		'1024': {
			slidesPerView: 3,
			spaceBetween: 10,
			pagination: false,
		},
		'1440': {
			slidesPerView: 4,
			spaceBetween: 10,
			pagination: false,
		},
	},
};
